
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/feature-requests",
      function () {
        return require("private-next-pages/resources/feature-requests.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/feature-requests"])
      });
    }
  